export const en = {
  // Common
  "common": {
    "welcome": "Welcome to",
    "search": "Search",
    "loading": "Loading...",
    "error": "An error occurred",
    "save": "Save",
    "cancel": "Cancel",
    "delete": "Delete",
    "edit": "Edit",
    "view": "View",
    "viewAll": "View all",
    "add": "Add",
    "remove": "Remove",
    "back": "Back",
    "next": "Next",
    "previous": "Previous",
    "submit": "Submit",
    "confirm": "Confirm",
    "success": "Success",
    "warning": "Warning",
    "info": "Information",
    "required": "Required",
    "optional": "Optional",
    "all": "All",
    "active": "Active",
    "inactive": "Inactive",
    "pending": "Pending",
    "completed": "Completed",
    "cancelled": "Cancelled",
    "rejected": "Rejected",
    "approved": "Approved",
    "yes": "Yes",
    "no": "No",
    "or": "or",
    "and": "and",
    "saving": "Saving...",
    "updating": "Updating...",
    "deleting": "Deleting...",
    "processing": "Processing...",
    "pleaseWait": "Please wait...",
    "notFound": "Not found",
    "noResults": "No results found",
    "noData": "No data available",
    "close": "Close",
    "apply": "Apply",
    "reset": "Reset",
    "clearAll": "Clear all",
    "clearFilters": "Clear filters",
    "retry": "Retry"
  },
  
  // Navigation
  "nav": {
    "home": "Home",
    "products": "Products",
    "videos": "Videos",
    "cart": "Cart",
    "wishlist": "Wishlist",
    "profile": "Profile",
    "settings": "Settings",
    "becomeSeller": "Become a Seller",
    "becomeDelivery": "Become a Delivery Partner",
    "sellerDashboard": "Seller Dashboard",
    "deliveryDashboard": "Delivery Dashboard",
    "management": "Management",
    "competitions": "Competitions",
    "login": "Login",
    "register": "Register",
    "logout": "Logout",
    "admin": "Admin Dashboard",
    "orders": "Orders",
    "sellers": "Sellers",
    "deliveryPartners": "Delivery Partners",
    "deliveries": "Deliveries",
    "users": "Users",
    "payments": "Payments",
    "paymentHistory": "Payment History"
  },
  
  // Home page
  "home": {
    "hero": {
      "title": "Welcome to AEM Marketplace",
      "subtitle": "Your one-stop destination for buying, selling, and delivering products with ease. Join our community of sellers and buyers today!",
      "browseProducts": "Browse Products",
      "becomeSeller": "Become a Seller"
    },
    "categories": {
      "title": "Popular Categories",
      "subtitle": "Explore our wide range of products"
    },
    "featuredProducts": {
      "title": "Featured Products"
    },
    "testimonials": {
      "title": "What Our Users Say",
      "subtitle": "Discover experiences from our growing community",
      "buyer": "Buyer",
      "seller": "Seller",
      "delivery": "Delivery Partner"
    },
    "stats": {
      "title": "AEM Marketplace by the Numbers",
      "subtitle": "Join our growing community today",
      "users": "Users",
      "products": "Products",
      "deliveries": "Deliveries",
      "satisfaction": "Satisfaction"
    },
    "howItWorks": {
      "title": "How It Works",
      "subtitle": "Buy and sell with ease on our platform",
      "cta": "Get Started Now",
      "step1": {
        "title": "Browse Products",
        "description": "Explore our vast catalog of quality products"
      },
      "step2": {
        "title": "Place Order",
        "description": "Choose your items and make secure payment"
      },
      "step3": {
        "title": "Fast Delivery",
        "description": "Our delivery partners take care of everything"
      },
      "step4": {
        "title": "Enjoy Your Purchase",
        "description": "Receive your products and share your experience"
      }
    }
  },
  
  // Products
  "products": {
    "title": "All Products",
    "subtitle": "Browse through our collection of unique products",
    "filters": "Filters",
    "activeFilters": "Active filters",
    "noProductsFound": "No products match your search criteria",
    "sort": {
      "title": "Sort by",
      "newest": "Newest",
      "priceAsc": "Price: Low to High",
      "priceDesc": "Price: High to Low",
      "popular": "Most Popular"
    },
    "addToCart": "Add to Cart",
    "addedToCart": "Added to Cart",
    "outOfStock": "Out of Stock",
    "price": "Price",
    "minPrice": "Min Price",
    "category": "Category",
    "seller": "Seller",
    "description": "Description",
    "deliveryOptions": "Delivery Options",
    "standard": "Standard",
    "express": "Express",
    "pickup": "Pickup",
    "pickupAddress": "Pickup Address",
    "estimatedDelivery": "Estimated Delivery",
    "days": "days",
    "reviews": "Reviews",
    "writeReview": "Write a Review",
    "noReviews": "No reviews yet",
    "rating": "Rating",
    "comment": "Comment",
    "submitReview": "Submit Review",
    "productDetails": "Product Details"
  },
  
  // Cart
  "cart": {
    "title": "Your Cart",
    "empty": "Your cart is empty",
    "addProducts": "Add products to start shopping",
    "browseProducts": "Browse Products",
    "summary": "Order Summary",
    "subtotal": "Subtotal",
    "shipping": "Shipping",
    "tax": "Tax",
    "total": "Total",
    "checkout": "Checkout",
    "continueShopping": "Continue Shopping",
    "remove": "Remove",
    "quantity": "Quantity",
    "delivery": "Delivery",
    "payment": "Payment",
    "deliveryInfo": "Delivery Information",
    "address": "Address",
    "city": "City",
    "zipCode": "Zip Code",
    "phone": "Phone",
    "continueToDelivery": "Continue to Delivery",
    "continueToPayment": "Continue to Payment",
    "finalizePayment": "Finalize Payment",
    "paymentSuccess": "Payment Successful!",
    "orderConfirmed": "Your order has been confirmed and will be processed promptly. You will receive an email confirmation with your order details.",
    "redirecting": "Redirecting to products page..."
  },
  
  // Auth
  "auth": {
    "login": {
      "title": "Welcome to AEM",
      "subtitle": "Log in to your account",
      "noAccount": "Don't have an account?",
      "createAccount": "Create an account",
      "email": "Email address",
      "password": "Password",
      "forgotPassword": "Forgot password?",
      "loginButton": "Log in",
      "loggingIn": "Logging in..."
    },
    "register": {
      "title": "Create your account",
      "subtitle": "Already have an account?",
      "signIn": "Sign in",
      "email": "Email address",
      "password": "Password",
      "role": "I want to",
      "buy": "Buy",
      "sell": "Sell",
      "deliver": "Deliver",
      "createButton": "Create account",
      "creating": "Creating account..."
    }
  },
  
  // Settings
  "settings": {
    "title": "Settings",
    "subtitle": "Manage your preferences and account information",
    "tabs": {
      "profile": "Profile",
      "security": "Security",
      "notifications": "Notifications",
      "language": "Language & Region"
    },
    "profile": {
      "fullName": "Full Name",
      "email": "Email",
      "emailCannotBeChanged": "Email cannot be changed",
      "phoneNumber": "Phone Number",
      "region": "Region",
      "regionPlaceholder": "Your region (e.g., Port-au-Prince)",
      "saveChanges": "Save Changes",
      "saving": "Saving..."
    },
    "security": {
      "currentPassword": "Current Password",
      "newPassword": "New Password",
      "confirmPassword": "Confirm Password",
      "passwordRequirements": "Password must be at least 6 characters long",
      "securityTips": "Security Tips",
      "tip1": "Use a unique password for each site",
      "tip2": "Include uppercase letters, lowercase letters, numbers, and symbols",
      "tip3": "Avoid using easily guessable personal information",
      "updatePassword": "Update Password",
      "updating": "Updating..."
    },
    "notifications": {
      "emailNotifications": "Email notifications",
      "allNotifications": "All notifications",
      "orderUpdates": "Order updates",
      "statusAndDelivery": "Status and delivery",
      "marketingEmails": "Marketing emails",
      "promotionsAndOffers": "Promotions and offers",
      "newMessages": "New messages",
      "chatsAndNegotiations": "Chats and negotiations",
      "aboutNotifications": "About Notifications",
      "notificationsHelp": "Notifications help you stay informed about important activities on your account. You can customize them according to your preferences.",
      "savePreferences": "Save Preferences"
    },
    "language": {
      "language": "Language",
      "region": "Region",
      "regionPlaceholder": "Your region (e.g., Port-au-Prince)",
      "regionalPreferences": "Regional Preferences",
      "regionalPreferencesHelp": "These settings affect how dates, prices, and other regional elements are displayed.",
      "savePreferences": "Save Preferences"
    },
    "deleteAccount": {
      "title": "Delete Account",
      "warning": "Once you delete your account, all your data will be permanently erased. This action cannot be undone.",
      "deleteButton": "Delete Account",
      "disabledMessage": "Account deletion is disabled in this demo"
    }
  },
  
  // Seller
  "seller": {
    "dashboard": {
      "title": "Seller Dashboard",
      "products": "Products",
      "orders": "Orders",
      "delivery": "Deliveries",
      "videos": "Videos",
      "revenue": "Revenue",
      "payments": "Payments",
      "settings": "Settings",
      "addProduct": "Add Product",
      "searchProduct": "Search for a product...",
      "noProducts": "No products yet",
      "productLimitReached": "Product limit reached",
      "views": "views",
      "sales": "sales",
      "active": "active"
    }
  },
  
  // Videos
  "videos": {
    "title": "Product Videos",
    "subtitle": "Watch product demonstrations and reviews from our community",
    "myVideos": "My Videos",
    "allVideos": "All Videos",
    "uploadVideo": "Upload Video",
    "noVideos": "No videos yet",
    "uploadYourFirst": "Upload your first video",
    "recent": "Recent",
    "popular": "Popular",
    "views": "views",
    "likes": "likes",
    "comments": "comments",
    "addComment": "Add a comment...",
    "loginToComment": "Log in to add a comment",
    "noComments": "No comments yet",
    "relatedProduct": "Related Product",
    "viewProduct": "View Product",
    "statistics": "Statistics",
    "publishedOn": "Published on",
    "deleteVideo": "Delete Video",
    "deleteConfirmation": "Are you sure you want to delete this video? This action cannot be undone.",
    "videoDeleted": "Video deleted successfully"
  }
};